import { setDate } from "date-fns";
import { FaOldRepublic } from "react-icons/fa";

function dateFormatter(date) {
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const [year, month, day] = date.split("-");
  const formatted = [month, day, year].join("/");
  const newDate = new Date(formatted);
  return days[newDate.getDay()] + " " + formatted;
}

function formatCpr(cpr) {

  // has it been 60 days past the original cpr date? If yes, we cannot extend this CPR anymore.
  // if original_due_date is no set, we use the due_date, which shoud evaluate to false.
  const blockDate = new Date(cpr.original_due_date || cpr.due_date);
  let extensionsMaxed = parseInt(((new Date()) - blockDate)/(60*60*24*1000)) <= 60 ? false : true

  return {
    originalDueDate: cpr.original_due_date && dateFormatter(cpr.original_due_date),
    updatedDueDate: false,
    updatedApointmentDate: false,
    acknowledgedAfterOutcome: false,
    extensionsMaxed: extensionsMaxed,
    date:
      cpr.completed_on_date || cpr.appointment_date || cpr.due_date
        ? dateFormatter(
            cpr.completed_on_date
              ? cpr.completed_on_date
              : cpr.appointment_date
              ? cpr.appointment_date
              : cpr.due_date
          )
        : "",
    progress: {
      status: cpr.sub_status == "patient_reported_completed" ? cpr.sub_status : cpr.status,
    },
    ...cpr,
  };
}

function Reducer(state, action) {
  switch (action.type) {
    case "set_completed_cprs_page_and_count":
      return {
        ...state,
        completed: {
          ...action.payload,
        },
      };
    case "set_in_progress_cprs_page_and_count":
      return {
        ...state,
        in_progress: {
          ...action.payload,
        },
      };
    case "set_cpr_page":
      return {
        ...state,
        cpr_page: action.payload,
      };
    case "set_initial_cprs":
      let cprs = [];
      let cprsNeedsAttention = !state.notifications ? [] : [...state.notifications];

      if (action.payload.cprs) {
        action.payload.cprs.forEach((cpr) => {
          let item = formatCpr(cpr);
          if (!item.needs_attention) {
            cprs.push(item);
          } else {
            cprsNeedsAttention.push(item);
          }
        });

      }

      return {
        ...state,
        cprs: cprs,
        notifications: cprsNeedsAttention,
      };
    case "set_notifications":
      return {
        ...state,
        notifications: [...action.payload.cprs.map((cpr) => formatCpr(cpr))].filter(
          (i) => i.needs_attention
        ),
      };
    case "set_all_cprs":
      let cprsCopy = [...state.cprs];
      let notificationsCopy = [...state.notifications];
      action.payload.cprs.forEach((cpr) => {
        let item = formatCpr(cpr);
        if (item.needs_attention) {
          let idx = notificationsCopy.findIndex((i) => i.id == item.id);
          idx <= -1
            ? (notificationsCopy = [...notificationsCopy, { ...item }])
            : (notificationsCopy = [...notificationsCopy]);
        } else {
          let idx = cprsCopy.findIndex((i) => i.id == item.id);
          idx <= -1 ? (cprsCopy = [...cprsCopy, { ...item }]) : (cprsCopy = [...cprsCopy]);
        }
      });
      return {
        ...state,
        cprs: [...cprsCopy],
        notifications: [...notificationsCopy],
      };
    case "set_completed":
      let completedCopy = !state.completed_cprs ? [] : [...state.completed_cprs];
      return {
        ...state,
        completed_cprs: [
          ...completedCopy,
          ...action.payload.cprs.map((cpr) => formatCpr(cpr)),
        ].sort((a, b) => new Date(b.completed_on_date) - new Date(a.completed_on_date)),
      };
    case "set_current_pcp_practice":
      return {
        ...state,
        pcp_practice: action.payload
      };
    case "set_current_cpr":
      let current = formatCpr(action.payload);
      if (!!state.notifications.length > 0) {
        return {
          ...state,
          notifications: [
            ...state.notifications.map((n) => (n.id == current.id ? { ...current } : n)),
          ],
          cprs: [...state.cprs.map((i) => (i.id == current.id ? { ...current } : i))],
          current: current,
        };
      } else {
        return {
          ...state,
          cprs: [...state.cprs.map((i) => (i.id == current.id ? { ...current } : i))],
          current: current,
        };
      }
    case "set_data":
      return {
        ...state,
        loading: false,
        ...action.payload,
      };
    case "set_support_messages":
      return {
        ...state,
        support_messages: action.payload,
      };
    case "set_cpr_task_messages":
      let cprUpdated = {
        ...state.current,
        task_messages: action.payload,
      };
      let copyCprs = [...state.cprs];
      let indexCpr = copyCprs.findIndex((i) => i.id == state.current.id);
      if (indexCpr > -1) {
        copyCprs = [
          ...copyCprs.map((cpr) => (cpr.id == state.current.id ? { ...cprUpdated } : { ...cpr })),
        ];
        return {
          ...state,
          cprs: copyCprs,
          current: cprUpdated,
        };
      } else {
        if (!!state.notifications.length > 0) {
          let copyNotifications = [...state.notifications];
          let indexNotification = copyNotifications.findIndex((i) => i.id == state.current.id);
          if (indexNotification > -1) {
            copyNotifications = [
              ...copyNotifications.map((cpr) =>
                cpr.id == state.current.id ? { ...cprUpdated } : { ...cpr }
              ),
            ];
            return {
              ...state,
              notifications: copyNotifications,
              current: cprUpdated,
            };
          }
        }
      }
    case "set_current_by_index":
      return {
        ...state,
        current: action.payload,
      };
    case "set_patient_consented":
      return {
        ...state,
        patient_consented_to_notifications: true,
      };
    case "set_current_in_progress_cprs":
      let allCprs = [...state.cprs];
      let index = allCprs.findIndex((i) => i.id == action.payload.id);
      if (index <= -1 && action.payload.needs_attention == false) {
        return {
          ...state,
          cprs: [...allCprs, { ...action.payload }],
        };
      } else {
        return {
          ...state,
        };
      }
    case "set_notification_updated":
      let filtered = [...state.notifications.filter((i) => i.id !== action.payload)];
      return {
        ...state,
        notifications: filtered,
        current: filtered[0],
      };
    case "set_initial_messages":
      let newOld = [];
      let newM = [];
      if (action.payload.count == 0) {
        return {
          ...state,
          messages: [],
          active_message: null,
          old: [],
          total_messages: action.payload.count,
        };
      } else {
        let messagesArr = [
          ...action.payload.messages.map((m) => {
            if (m.status == "responded") {
              return {
                ...m,
                questions: m.questions.map((i, idx) => {
                  let value = m.custom_responses[0].options[idx]
                    ? m.custom_responses[0].options[idx].id
                    : null;
                  return { ...i, value: value };
                }),
              };
            } else {
              return {
                ...m,
                questions: m.questions ? m.questions.map((i) => {
                  return {
                    ...i,
                    value: "",
                  };
                }) : [],
              };
            }
          }),
        ].reverse();
        [...messagesArr.filter((i) => i.status == "responded")].forEach((item) => {
          let i = newOld.findIndex((x) => x.id == item.id);
          if (i <= -1) {
            newOld.push({ ...item });
          }
        });
        [...messagesArr.filter((i) => i.status !== "responded")].forEach((item) => {
          let i = newM.findIndex((x) => x.id == item.id);
          if (i <= -1) {
            newM.push({ ...item });
          }
        });
        return {
          ...state,
          total_messages: action.payload.count,
          active_message: newM[0],
          messages: newM,
          old: newOld,
        };
      }
    case "set_more_messages":
      let all = [
        ...action.payload.messages.map((m) => {
          if (m.status == "responded") {
            return {
              ...m,
              questions: m.questions.map((i, idx) => {
                return { ...i, value: m.custom_responses[0].options[idx].id };
              }),
            };
          } else {
            return {
              ...m,
              questions: m.questions ? m.questions.map((i) => {
                return {
                  ...i,
                  value: "",
                };
              }) : [],
            };
          }
        }),
      ].reverse();
      return {
        ...state,
        messages: [...state.messages, ...all.filter((i) => i.status !== "responded")],
        old: [...state.old, ...all.filter((i) => i.status == "responded")],
      };
    case "remove_active_message":
      let newMessages = [...state.messages.filter((i) => i.id !== action.payload)];
      return {
        ...state,
        active: !!newMessages.length > 0 ? newMessages[0] : null,
        messages: newMessages,
      };
    case "set_message_responded":
      let message = state.messages.filter((m) => m.id == action.payload.id)[0];
      message = {
        ...message,
        status: "responded",
        date_responded: new Date(),
        questions: message.questions.map((i, idx) => {
          return {
            ...i,
            value: action.payload.options_ids[idx],
          };
        }),
      };
      let messagesNew = [
        ...state.messages.filter((i) => i.id !== action.payload.id),
        { ...message },
      ];
      return {
        ...state,
        active_message: message,
        messages: messagesNew,
        old: [
          {
            ...message,
          },
          ...state.old,
        ],
      };
    case "set_active_message":
      let m = action.payload;
      if (m.status == "responded") {
        m = {
          ...m,
          questions: m.questions.map((i, idx) => {
            return { ...i };
          }),
        };
      } else {
        m = {
          ...m,
          questions: m.questions.map((i) => {
            return {
              ...i,
              value: "",
            };
          }),
        };
      }
      if (state.messages.find((i) => i.id == m.id) || state.old.find((i) => i.id == m.id)) {
        return {
          ...state,
          active_message: m,
        };
      } else {
        return {
          ...state,
          messages: [...state.messages, { ...m }],
          active_message: m,
        };
      }
    default:
      return state;
  }
}
export default Reducer;
